// extracted by mini-css-extract-plugin
module.exports = {"copyIcon":"styles_copyIcon__jbaVb","copyIconDisabled":"styles_copyIconDisabled__3fVDw","disabledOption":"styles_disabledOption__2wvCU","dateTime":"styles_dateTime__1_qF3"};